import React from "react";

function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-10">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-opacity-75"></div>
    </div>
  );
}

export default Loader;
